<template>
<div class="info-board">
	<div class="row">
		<div class="col-md-3">
			<button @click="save"
			        type="button"
			        class="btn btn-default btn-lg info-board__save">Opslaan</button>
		</div>
		<div class="col-md-6">
			<transition name="fade">
				<div v-show="showAlert"
				     class="info-board__alert">
					U kunt geen speeltoestellen op dezelfde plaats neerzetten.
				</div>
			</transition>
		</div>
		<div class="col-md-3">
			<div class="info-board__money pull-right"
			     :style="{ color: budget < 0 ? 'red' : false}">
				&euro; {{ budget }}
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
	data: () => ({}),
	props: {
		budget: {
			type: Number,
			required: true
		},
		showAlert: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		save() {
			this.$emit('save-design');
		}
	}
}
</script>
<style lang="scss" scoped>
.info-board {
    height: 60px;
    //background-color: rgb(76, 140, 228);
    background-color: #B0CFFB;
    color: #175262;
    overflow: hidden;

    &__alert {
        margin-top: 14px;
        background-color: rgb(221, 51, 51);
        color: white;
        padding: 10px;
        font-size: 0.92em;
    }

    &__money {
        font-size: 20px;
        line-height: 40px;
        margin: 15px 20px;
    }

    &__save {
        background-color: #175262;
        color: #FFF;
        border-radius: 0;
        border: none;
        font-size: 0.92em;
        margin: 14px;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// assets/vue/apps/participate/info-board.vue